import { useContext, useState, useEffect } from "react"
import { push as Menu } from "react-burger-menu"
import { PageContext } from "./PageProvider"
import LinkWrapper from "./LinkWrapper"
import { useMainMenuItems } from "../utils/useMainMenuItems"
import AnimateHeight from "react-animate-height"
import get from "lodash/get"
import getLocalizedString from "../utils/getLocalizedString"

const MobileMenu = ({ global, currentLanguage }) => {
  const ctx = useContext(PageContext)
  const navigationItems = useMainMenuItems(global, currentLanguage)

  var styles = {
    bmItemList: {
      color: "",
      padding: "",
    },
    bmCross: {
      background: "transparent",
    },
  }

  return (
    <Menu
      customBurgerIcon={false}
      isOpen={ctx.isMenuOpen}
      onStateChange={(state) => ctx.stateChangeHandler(state)}
      outerContainerId={"wrapper-outter"}
      pageWrapId={"wrapper-inner"}
      right
      styles={styles}
      menuClassName="py-16 pl-8 pr-4 bg-gray-800 shadow-[inset_0.5rem_0_0.5rem_0_rgba(0,0,0,.28235)]"
      overlayClassName="!bg-black/30"
      crossButtonClassName="h-6 w-6 mr-2 mt-1 text-white rounded-full transition-colors duration-150 hover:bg-black/25 focus:outline-none focus:bg-black/25 text-center"
      customCrossIcon={<i className="icon-x"></i>}
    >
      <ul>
        {navigationItems.map((navigationItem, index) => {
          const links = []

          navigationItem.components.forEach((component) => {
            if (!component.links) {
              return
            }

            component.links.forEach((child) => links.push(child))
          })

          return (
            links.length && (
              <MenuItem
                item={navigationItem}
                links={links}
                key={navigationItem.id}
              />
            )
          )
        })}
      </ul>
    </Menu>
  )
}

const MenuItem = ({ item, links, level = 0 }) => {
  const ctx = useContext(PageContext)
  const localizedStrings = ctx.localizedStrings
  const localizedOverview = getLocalizedString(
    localizedStrings,
    "localization_string___overview",
    "Overview"
  )
  const [isOpen, setIsOpen] = useState(false)
  const [height, setHeight] = useState(0)

  let parentIndentClass = `pl-1`
  let childIndentClass = `pl-4`
  const linkClassName = `rounded p-1 text-white bg-transparent border-0 block w-full text-left relative leading-loose pr-4 hover:bg-black/25 focus:bg-black/25 focus:text-white focus:outline-none transition-colors duration-150`
  const activeLinkClassName = `!bg-gray-300 !text-gray-900`

  // Indent items based on level to indicate hierarchy
  switch (level) {
    case 2:
      parentIndentClass = `pl-8`
      childIndentClass = `pl-12`
      break
    case 1:
      parentIndentClass = `pl-4`
      childIndentClass = `pl-8`
      break
    case 0:
    default:
      break
  }

  useEffect(() => {
    setHeight(isOpen ? `auto` : 0)
  }, [isOpen])
  const toggle = () => setIsOpen(!isOpen)

  return (
    <li className="block border-t border-gray-900">
      {links && links.length ? (
        <>
          <button
            className={`${linkClassName} my-1px ${parentIndentClass}`}
            onClick={toggle}
          >
            {item.label}{" "}
            <i
              className={`absolute right-0 top-1/2 -translate-y-1/2 leading-loose mr-1 icon-chevron-down transition-all duration-300 transform ${
                isOpen ? `rotate-180` : ``
              }`}
            ></i>
          </button>
          <AnimateHeight duration={300} height={height}>
            <ul className="text-sm">
              <li className="border-t border-gray-900">
                {item.linkTo || item.url ? (
                  <LinkWrapper
                    className={`${linkClassName} ${childIndentClass} my-1px`}
                    activeClassName={activeLinkClassName}
                    to={item.linkTo || item.url}
                  >
                    {localizedOverview}
                  </LinkWrapper>
                ) : null}
              </li>
              {links.map((child) => (
                <MenuItem
                  item={child}
                  links={child.links || []}
                  key={child.id}
                  level={level + 1}
                />
              ))}
            </ul>
          </AnimateHeight>
        </>
      ) : !item.url ? (
        <button>{item.label}</button>
      ) : (
        <LinkWrapper
          to={item.url}
          className={`${linkClassName} ${parentIndentClass} my-1px`}
          activeClassName={activeLinkClassName}
          {...(get(item, "type") === "redirect" ? { target: "_blank" } : false)}
        >
          {item.label}
        </LinkWrapper>
      )}
    </li>
  )
}

export default MobileMenu
